import {visit} from 'unist-util-visit';
import type {Link, Parent, Root, Text} from 'mdast';

export function transformAtUserLinks(): (tree: Root) => void {
    return (tree: Root) => {
        visit(tree, 'text', (node: Text, index, parent) => {
            if (!parent || index === undefined) return;
            const regex = /@([a-zA-Z0-9_]+)/g;
            const segments: (Text | Link)[] = [];
            let lastIndex = 0;
            let match;

            while ((match = regex.exec(node.value)) !== null) {
                const [raw, username] = match;
                const start = match.index;
                if (start > lastIndex) {
                    segments.push({
                        type: 'text',
                        value: node.value.slice(lastIndex, start),
                    } as Text);
                }
                segments.push({
                    type: 'link',
                    url: `/users/${username}`,
                    title: null,
                    children: [{type: 'text', value: `@${username}`}],
                } as import('mdast').Link);
                lastIndex = start + raw.length;
            }

            if (lastIndex < node.value.length) {
                segments.push({
                    type: 'text',
                    value: node.value.slice(lastIndex),
                } as Text);
            }

            if (segments.length > 0) {
                (parent as Parent).children.splice(index, 1, ...segments);
            }
        });
    };
}
